var _circle, _mask, _g, _path, _path2, _circle2, _rect, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar05(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.912,
    cy: 16.151,
    r: 15.5,
    fill: "#D8D1FA",
    stroke: "#CEC7F1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "avatar-05_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 29,
    height: 29
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.912,
    cy: 16.151,
    r: 13.5,
    fill: "#D8D1FA",
    stroke: "#BAB2E2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#avatar-05_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 32V23.25l-.042-3.864v-3c0-2.466-1-4.686-2.625-6.289a8.988 8.988 0 00-6.5-2.589C11.917 7.59 8 11.7 8 16.59V32h18z",
    fill: "#A294E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#8D80CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.633 17.072s-.133-.75-.97-.75c-.836 0-1.03.75-1.03.75",
    stroke: "#8D80CB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.883 22.222a.79.79 0 00-.01.145c.036 1.439 1.158 2.738 2.466 3.505.78.459 1.698.734 2.615.734.963 0 2.018-.321 2.89-.872 1.238-.78 2.156-2.018 2.156-3.44v-.83a.46.46 0 00-.459-.458l-8.81.456a.906.906 0 00-.848.76z",
    fill: "#8E81CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.52 25.952a5.202 5.202 0 01-2.474.654c-.963 0-2.018-.321-2.89-.872a5.386 5.386 0 01-1.056-.864 3.752 3.752 0 016.42 1.082z",
    fill: "#7D70BE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.556,
    cy: 24.631,
    r: 2.912,
    transform: "rotate(13 24.556 24.63)",
    fill: "#C0B3FD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.022,
    y: 18.656,
    width: 2.328,
    height: 6.988,
    rx: 1.164,
    transform: "rotate(3 23.022 18.656)",
    fill: "#C0B3FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.078,
    y: 21.897,
    width: 2.912,
    height: 2.912,
    rx: 1.456,
    transform: "rotate(3 21.078 21.897)",
    fill: "#CABEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.265 24.524a1.164 1.164 0 002.143.91l1.82-4.29a1.164 1.164 0 10-2.142-.91l-1.82 4.29z",
    fill: "#C0B3FD"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgAvatar05 as ReactComponent };